import { type Ref } from "vue";
import * as Cesium from "cesium";

type JakartoWMTSStyle = "color" | "classification" | "color_lowest_z" | "max_intensity" | "low_z_max_intensity" | "hillshade" | "verticality";
export type WMTSType = "none" | JakartoWMTSStyle;

export function useJakartoWMTS(viewer: Ref<Cesium.Viewer | null>, selectedWMTS: Ref<WMTSType>) {
    let jakartoWMTSLayer: Cesium.ImageryLayer | null = null;

    const changeJakartoWMTS = async (): Promise<void> => {
        if (!viewer.value) return;
        if (jakartoWMTSLayer) {
            viewer.value.imageryLayers.remove(jakartoWMTSLayer, true);
            jakartoWMTSLayer = null;
        }
        if (selectedWMTS.value === "none") {
            return;
        }

        Cesium.TrustedServers.add("tiles.jakarto.com", 443);

        const style = selectedWMTS.value;
        const url = `https://tiles.jakarto.com/v1/xyz/{z}/{x}/{y}?crs=webmercator&style=${style}`;

        const provider = new Cesium.UrlTemplateImageryProvider({
            url,
            tilingScheme: new Cesium.WebMercatorTilingScheme(),
            maximumLevel: 23,
            credit: "Jakarto tiles",
        });

        jakartoWMTSLayer = viewer.value.imageryLayers.addImageryProvider(provider, 2);
    };

    return {
        selectedWMTS,
        changeJakartoWMTS,
    };
}
